import renderable from './renderable'

export default renderable